import React from 'react';
import { CardUserFinderProps } from './types';
import { Controls, LoaderWrapper, TextWrapper, UserName, Wrapper } from './card-user-request.style';
import { Photo } from '@shared/ui/photo/photo';
import { Typography } from '@shared/ui/typography/typography';
import { Preloader } from '@vtbhome/juicyfront';

export const CardUserFinder: React.FC<CardUserFinderProps> = ({
    avatarUrl,
    isLoading,
    userName,
    jobTitle,
    isAvailableHover = true,
    onClick,
    children,
}) => {
    const isShowHoverStyles = isAvailableHover && !isLoading;
    return (
        <Wrapper isShowHoverStyles={isShowHoverStyles} onClick={onClick}>
            <Photo size='l' photoUrl={avatarUrl} />
            <TextWrapper>
                <UserName size='body1_short'>{userName}</UserName>
                {jobTitle && (
                    <Typography size='body1_short' color='neutral_50'>
                        {jobTitle}
                    </Typography>
                )}
            </TextWrapper>
            {children && <Controls>{children}</Controls>}
            {isLoading && (
                <LoaderWrapper onClick={(e) => e.stopPropagation()}>
                    <Preloader />
                </LoaderWrapper>
            )}
        </Wrapper>
    );
};
